angular.module("analytics.mixpanel").service("AnalyticsService", [
  "mixpanel",
  function (mixpanel) {
    this.startEventTimer = (labelAction) => {
      mixpanel?.time_event(labelAction);
    };

    this.track = (actionName, properties) => {
      mixpanel?.track(actionName, { ...properties });
    };

    this.registerSuperProperties = (superProperties) => {
      mixpanel?.register({ ...superProperties });
    };

    this.unregisterSuperProperties = (propertyName) => {
      if (Array.isArray(propertyName)) {
        propertyName.forEach((property) => {
          mixpanel?.unregister(property);
        });
      } else {
        mixpanel?.unregister(propertyName);
      }
    };
  },
]);
